import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { telerikreport } from './telerik-report.model';
import { Subscription, Observable, of } from "rxjs";

@Injectable()

export class TelerikReportService {

  private messageObject = new Subject<telerikreport>();

  loaderState = this.messageObject.asObservable();

  constructor() { }

  show(reportname: string, parameter: string) {
    debugger
    this.messageObject.next(<telerikreport>{ show: true, reportname: reportname, parameter: parameter });
  }

  hide() {
    debugger
    this.messageObject.next(<telerikreport>{ show: false });
  }
  
 
}
